import {useCallback} from 'react';

import {getAvailableUserStatuses} from 'src/openapi/admin/apis/GetAvailableUserStatusesApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Error} from 'src/openapi/admin/models/Error';

export const useAvailableUserStatuses = () => {
    const apiDispatch = useAppDispatch();

    const getAvailableStatuses = useCallback(async (accountId: number) => {
        let loadedStatuses: string[] | Error = [];
        const availableStatusesResponse = await apiDispatch(getAvailableUserStatuses({accountId}));

        if (availableStatusesResponse.payload.success) {
            loadedStatuses = availableStatusesResponse.payload.data;
        } else {
            loadedStatuses = availableStatusesResponse.payload.data;
        }

        return loadedStatuses;
    }, [apiDispatch]);

    return {getAvailableStatuses};
};
